export default __webpack_public_path__ + "static/media/demons-respite.e99a1079.PNG";